// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/subscription.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.CustomerSubscription
 */
export const CustomerSubscription = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CustomerSubscription",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "billing_cycle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "billing_interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "lines", kind: "message", T: SubscriptionLineItem, repeated: true },
    { no: 9, name: "current_period_start", kind: "message", T: Timestamp },
    { no: 10, name: "current_period_end", kind: "message", T: Timestamp },
    { no: 11, name: "trial_end", kind: "message", T: Timestamp },
    { no: 12, name: "payment_retries", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "max_payment_retries", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "payment_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "metadata", kind: "message", T: Struct },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
    { no: 32, name: "cancelled_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.SubscriptionLineItem
 */
export const SubscriptionLineItem = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubscriptionLineItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateCustomerSubscriptionRequest
 */
export const CreateCustomerSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateCustomerSubscriptionRequest",
  () => [
    { no: 1, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "billing_cycle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "billing_interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lines", kind: "message", T: SubscriptionLineItem, repeated: true },
    { no: 6, name: "payment_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "trial_end", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetCustomerSubscriptionRequest
 */
export const GetCustomerSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCustomerSubscriptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCustomerSubscriptionsRequest
 */
export const ListCustomerSubscriptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCustomerSubscriptionsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCustomerSubscriptionsResponse
 */
export const ListCustomerSubscriptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCustomerSubscriptionsResponse",
  () => [
    { no: 1, name: "subscriptions", kind: "message", T: CustomerSubscription, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.PauseCustomerSubscriptionRequest
 */
export const PauseCustomerSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PauseCustomerSubscriptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ResumeCustomerSubscriptionRequest
 */
export const ResumeCustomerSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResumeCustomerSubscriptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelCustomerSubscriptionRequest
 */
export const CancelCustomerSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelCustomerSubscriptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateCustomerSubscriptionLinesRequest
 */
export const UpdateCustomerSubscriptionLinesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateCustomerSubscriptionLinesRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lines", kind: "message", T: SubscriptionLineItem, repeated: true },
  ],
);

